
import React from 'react';
import PropTypes from 'prop-types';

import CorrugatedImg1 from '../InstallImages/CorrugatedMetal/CorrugatedImg1';
import CorrugatedImg2 from '../InstallImages/CorrugatedMetal/CorrugatedImg2';
import CorrugatedImg3 from '../InstallImages/CorrugatedMetal/CorrugatedImg3';

import '../saleslogic.css';
import '../../../../../../grid.css';

const CorrugatedMetal = (props) => {
    const { firstName, systemSize } = props;

    // images are 952 x 406

    return (
        <div className="row" >
            <h1 className="arrayType">S-5!™ Metal Roofing Attachments</h1>
            <div className="row installTextGroup">
                <p className="col span-1-of-3 installText">
                    {firstName}, Standing-Seam, Exposed-Fastened, Trapezoidal Rib, and Corrugated Metal Roofing are some of the most versatile and robust roofing materials on which Solvana installs PV solar generating systems. These roofing choices provide stable surfaces suitable for supporting S-5!™ (https://s-5.com/products/solar-solutions/) metal roofing attachments. Before installing your Solvana {systemSize / 1000}kW PV solar-generating system, we match the profile of your metal roofing with S-5!™ metal roofing attachments specifically engineered for each unique roofing shape. Corrugated metal roofing attachments have a patented and factory-applied butyl sealant that creates a water-tight seal offering durability and reliability unmatched by adhesives that degrade over time with heat cycles, UV degradation, and ozone.
                </p>
                <p className="col span-2-of-3 installPics installPixRight">
                    <CorrugatedImg1 />
                </p>
            </div>
            <div className="row installTextGroup">
                <p className="col span-2-of-3 installPics">
                    <CorrugatedImg2 />
                </p>
                <p className="col span-1-of-3 installText">
                    Solvana secures standing-seam metal roofing attachments with S-5!™ zero-penetration technology, which does not compromise roofing manufacturer’s warranties. Solvana secures corrugated metal roofing attachments through factory-drilled holes using specific screws for each unique application. Solvana attaches solar racking components to the metal roofing attachments, and then we fasten the optimizers and modules to the solar racking components. In the pictures below, you can see corrugated roofing, metal roofing attachments, L-feet, rails, and optimizers, with the last picture showing 57 solar modules, which are supplying 100% of the energy for this home year-round. With Solvana designed PV solar-generating systems, we use best-in-class products to prevent roof leaks!
                </p>

            </div>
            <div className="row installTextGroup">
                <p className="col span-1-of-3">
                    <blockquote>
                        <p>Why I chose Solvana In 2016 my wife and I started our due-diligence on solar and solar companies and met with several firms, ultimately choosing Solvana LLC, a New Jersey company. We preferred them over the others because the owner, Ric, met with us multiple times during our research and answered all of our finance and technical questions immediately instead of saying “I’ll get back to you on that”. We initially wanted to install a diesel generator in the future but then learned about Tesla Powerwall batteries. It was an easy decision once we gained a better understanding of the marriage between solar and battery storage. Ric was a source of knowledge and professionalism before, during and after the install teaching me more and more about the industry. I started referring friends to Ric and in December 2018 I joined Solvana as a sales rep. After 24 months with solar, every expectation has been met or exceeded with my solar and storage system. Robert Swan
                        </p>
                    </blockquote>
                    <footer>
                        <cite>
                            - Robert S. Whitehouse Station, NJ
                        </cite>
                    </footer>
                </p>
                <p className="col span-2-of-3"><CorrugatedImg3 /></p>
            </div>

        </div>
    );
};

CorrugatedMetal.propTypes = {
    firstName: PropTypes.string.isRequired,
    systemSize: PropTypes.number.isRequired,
};

export default CorrugatedMetal;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/CorrugatedMetal/CorrugatedMetal.js